export default __webpack_public_path__ + "static/media/de.985efb1a.svg";